import React, { useEffect } from "react";
import "./CredibilityToolPage.scss";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";

import { LeftSide } from "./components/LeftSide";
import { RightSide } from "./components/RightSide";

function CredibilityToolPage() {
  const { identity, identifyError } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  useEffect(() => {
    if (Object.keys(identity).length > 0) {
      window.location.pathname = `/workspace`;
    }
  }, [identity, window.location.pathname]);

  return (
    <div className="credibility-tool-page">
      <LeftSide />

      <RightSide />
    </div>
  );
}

export { CredibilityToolPage };
